import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { login, enviarCodigoValidacao } from '../services';
import logo from '../assets/concreto_tec_logo.png';
import { saveSession } from '../services/authSession';

// Tela de login: autentica, salva a sessão e redireciona para /app.
function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || '');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(location.state?.mensagem || '');

  // Submete o login: chama a API, persiste a sessão e navega; exibe erro em caso de falha.
  const handleSubmit = async (event) => {
    event.preventDefault();
    setFeedback('');
    setLoading(true);
    try {
      const session = await login(email, senha);

      // Garante que o e-mail usado no login fique na sessão, mesmo que o backend não o retorne.
      saveSession({ ...session, email: session?.email || email });
      
      setFeedback('Entrando...'); 
      navigate('/app');
    } catch (error) {
      // Usuário ainda não validou o e-mail: dispara um novo código e leva para a tela de verificação.
      if (error.status === 401 && /n[aã]o validado/i.test(error.message || '')) {
        try {
          await enviarCodigoValidacao(email.trim());
        } catch (_) {
          // ignora: usuário ainda pode reenviar manualmente na próxima tela
        }
        navigate('/verificar-email', { state: { email, codigoReenviado: true } });
        return;
      }
      const mensagemErro = error.message || 'Email ou senha incorretos.';
      setFeedback(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page login-shell min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4 py-10 sm:py-0">
      <div className="login-card w-full max-w-md rounded-xl border border-slate-200 bg-white shadow-sm sm:shadow-lg">
        <div className="login-header px-5 pt-6 text-center sm:px-6">
          <div className="login-mark mx-auto flex items-center justify-center">
            <img src={logo} alt="Logo Kretos Lab" className="h-14 w-14 object-contain" />
          </div>
          <h1 className="login-title mt-4 text-2xl font-semibold text-slate-900">Kretos Lab</h1>
          <p className="login-subtitle mt-1 text-sm text-slate-500">
            Sistema de Controle e Análise de Concreto.
          </p>
        </div>
        <div className="login-body px-5 pb-6 pt-5 sm:px-6">
          <form onSubmit={handleSubmit} className="login-form space-y-4">
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm font-medium text-slate-700">
                Email
              </label>
              <input
                id="email"
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
                className="w-full rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              />
            </div>
            <div className="space-y-2">
              <label htmlFor="senha" className="text-sm font-medium text-slate-700">
                Senha
              </label>
              <input
                id="senha"
                type="password"
                placeholder="********"
                value={senha}
                onChange={(event) => setSenha(event.target.value)}
                required
                className="w-full rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              />
            </div>
            <button
              type="submit"
              className="w-full rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-70"
              disabled={loading}
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
          <div className="login-actions mt-4 flex items-center justify-between text-xs text-slate-500">
            <Link to="/esqueci-senha" className="text-blue-600 hover:text-blue-700">
              Esqueceu a senha?
            </Link>
            <Link to="/cadastro" className="text-blue-600 hover:text-blue-700">
              Cadastrar-se
            </Link>
          </div>
          {feedback ? (
            <p className="login-feedback mt-2 text-center text-xs text-slate-600">{feedback}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
